export const Types = {
  Text: 'text',
  Number: 'number',
  Monetary: 'monetary',
  Succession: 'succession',
  Date: 'date',
  Skill: 'skill',
  PositionShortlist: 'position-shortlist',
  Array: 'array'
}
